var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labelContent"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"btnBox"},[_vm._t("btns")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }